export default [
  {
    path: 'afiliados/afiliados-relatorios',
    name: 'afiliados-relatorios',
    component: () => import('./index'),
    children: [],
    meta: {
      visible: true,
      title: 'Relatórios',
      breadcrumb: [
        { name: 'Home', link: 'home' },
        { name: 'Afiliados', link: 'afiliados' },
        { name: 'Relatórios' }
      ]
    }
  },
]